import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { APP_ROUTES, UserRole } from '@/constants';
import { useAuth } from '@/hooks';
import { getAppConfigurations } from '@/common/utils';
import { trackEvent } from '@/common/services/tracking';
import useApplicationSettings from '@/hooks/useApplicationSettings';
import styles from './styles.module.scss';

const { myCoursesUrl, allAdvisorsUrl } = getAppConfigurations();

export const NavigationItems = ({
  className = '',
  onNavigateItemClick,
}: {
  className?: string;
  onNavigateItemClick?: VoidFunction;
}) => {
  const { appSettings } = useApplicationSettings();
  const { isUser, isAdvisor, isDecisionMaker, user } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isContentSubscriber = user?.roles.some((u) => u === UserRole.ContentSubscriber);
  const advisorOrUser = isUser || isAdvisor;

  const navigationContent = (
    <>
      {user && (
        <div
          className={styles.link}
          onClick={() => {
            onNavigateItemClick?.();
            navigate(APP_ROUTES.HOME);
            trackEvent('Navigation_Click_MyDashboard', 'NAVIGATION');
          }}
        >
          <span>{t('header.navigations.dashboard')}</span>
        </div>
      )}

      {advisorOrUser && (
        <>
          <div
            className={styles.link}
            onClick={() => {
              onNavigateItemClick?.();
              navigate(APP_ROUTES.MY_SESSIONS);
              trackEvent('Navigation_Click_MySession', 'NAVIGATION');
            }}
          >
            <span>{t('header.navigations.sessions')}</span>
          </div>
        </>
      )}

      {isAdvisor && appSettings.isFeedbackFeatureEnabled && (
        <div
          className={styles.link}
          onClick={() => {
            onNavigateItemClick?.();
            navigate(APP_ROUTES.MY_FEEDBACKS);
            trackEvent('Navigation_Click_MyFeedback', 'NAVIGATION');
          }}
        >
          <span>{t('header.navigations.feedbacks')}</span>
        </div>
      )}

      {isUser && appSettings.isUserFeedbackFeatureEnabled && (
        <div
          className={styles.link}
          onClick={() => {
            onNavigateItemClick?.();
            navigate(APP_ROUTES.MY_FEEDBACKS);
            trackEvent('Navigation_Click_MyFeedback', 'NAVIGATION');
          }}
        >
          <span>{t('header.navigations.feedbacks')}</span>
        </div>
      )}

      {isUser && (
        <div
          className={styles.link}
          onClick={() => {
            onNavigateItemClick?.();
            trackEvent('Navigation_Click_AllAdvisors', 'NAVIGATION');
            setTimeout(() => {
              window.open(allAdvisorsUrl, '_blank');
            }, 100);
          }}
        >
          <span>{t('header.navigations.advisors')}</span>
        </div>
      )}

      {isDecisionMaker && (
        <div
          className={styles.link}
          onClick={() => {
            onNavigateItemClick?.();
            navigate(APP_ROUTES.COMPANY);
            trackEvent('Navigation_Click_Company', 'NAVIGATION');
          }}
        >
          <span>{t('header.navigations.company')}</span>
        </div>
      )}

      {isContentSubscriber && (
        <div
          className={styles.link}
          onClick={() => {
            onNavigateItemClick?.();
            trackEvent('Navigation_Click_WisoryLearning', 'NAVIGATION');
            setTimeout(() => {
              window.open(myCoursesUrl, '_blank');
            }, 100);
          }}
        >
          <span>{t('header.navigations.courses')}</span>
        </div>
      )}
    </>
  );

  return <div className={classNames(styles.wrapper, className)}>{navigationContent}</div>;
};
